import * as React from 'react'
import { FunctionComponent } from 'react'
import TableContext, {
  createTableContext,
} from '../../../contexts/TableContext'
import ClicksTable from './ClicksTable'

import {
  ClickDetailReportingSorts,
  ClickDetailReportingQueryVariables,
  useClickDetailReportingLazyQuery,
} from '../../../generated/types'

type ClicksSorts =
  | 'clickId'
  | 'clickDate'
  | 'programName'
  | 'productName'
  | 'productTypeName'
  | 'productId'
  | 'subTracking'
  | 'state'
  | 'campaignName'
  | 'sales'
  | 'commissions'
  | 'pagePath'

interface ClicksFilters {
  dateRange: string
  startDate: string
  endDate: string
  vertical: string
  productType: string
  program: string
  product: string
  campaign: string
  clickedProduct: string
  subTracking: string
}

export type ClickDetailReportVariables = ClickDetailReportingQueryVariables

export type ClickDetailReportSorts = keyof ClickDetailReportingSorts

export const ClicksTableContext = createTableContext<
  ClicksFilters,
  ClicksSorts
>()

const ClicksReport: FunctionComponent = () => {
  const [
    ClickDetailReportingResult,
    { data, loading, error },
  ] = useClickDetailReportingLazyQuery({
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
  })
  const [
    ClickDetailReportingExportResult,
    { data: exportData, loading: exportLoading, error: exportError },
  ] = useClickDetailReportingLazyQuery({
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
  })
  return (
    <TableContext<ClicksFilters, ClicksSorts>
      Context={ClicksTableContext}
      queryParams={[
        'dateRange',
        'startDate',
        'endDate',
        'vertical',
        'productType',
        'program',
        'product',
        'campaign',
        'clickedProduct',
        'subTracking',
      ]}
    >
      <ClicksTable
        getData={ClickDetailReportingResult}
        data={data}
        loading={loading}
        error={error != null}
        getExportData={ClickDetailReportingExportResult}
        exportData={exportData}
        exportLoading={exportLoading}
        exportError={exportError != null}
      />
    </TableContext>
  )
}

export default ClicksReport
